import { api } from "./api";

const damageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDamages: builder.query({
      query: () => "damageproduct",
      providesTags: ["damageproduct"],
    }),
    addDamage: builder.mutation({
      query: (newCategory) => ({
        url: "damageproduct",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["damageproduct"],
    }),
    removeDamage: builder.mutation({
      query: (id) => ({
        url: `damageproduct/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["damageproduct"],
    }),
    editDamage: builder.mutation({
      query: (editData) => ({
        url: `damageproduct`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["damageproduct"],
    }),
  }),
});

export const {
  useGetDamagesQuery,
  useAddDamageMutation,
  useRemoveDamageMutation,
  useEditDamageMutation,
} = damageApi;